import React from 'react';
import { Link } from 'react-router-dom';
import './ContactCTA.css';

const ContactCTA = () => {
  return (
    <div className="contact-cta">
      <div className="cta-content">
        <div className="cta-text">
          <h2>让我们一起合作，<br/>打造超级好看和超级有用的作品。</h2>
          <Link to="/contact" className="contact-button">联系我</Link>
        </div>
        <div className="cta-image">
          <img src="/images/cta_image.png" alt="联系我们" />
        </div>
      </div>
    </div>
  );
};

export default ContactCTA; 